import { Icon } from 'client/components/Icons/Icon'
import { l } from 'client/Other/Translation'
import { setBaseClass } from 'client/utils'
import React from 'react'

import './CSSToolTip.scss'

interface ICSSTooltipProps {
  position?: 'top' | 'left' | 'right' | 'bottom'
  header?: string | JSX.Element
  body?: string | JSX.Element
  helpTooltipPositionAbsolute?: boolean
  icon?: JSX.Element
}

const CSSToolTip: React.FC<ICSSTooltipProps> = ({ position, header, body, helpTooltipPositionAbsolute, icon }) => {
  const cls = setBaseClass('CSSToolTip')
  const classes = { __container: true }
  classes[`__container--${position || 'top'}`] = true

  return (
    <div className={`${cls()}${helpTooltipPositionAbsolute ? ' absolute' : ''}`}>
      {icon || <Icon type="question-mark" />}
      <div className={cls(classes)}>
        {header && <div className={cls('__header')}>{header}</div>}
        <div className={cls('__body')}>{body}</div>
        <div className="__arrow">
          <i />
        </div>
      </div>
    </div>
  )
}

export default CSSToolTip
